import {
  params,
  shape as shapeType,
  arrayOf as arrayType,
  number as numberType,
  string as stringType,
  extend,
  alias
} from '@thd-nucleus/data-sources';
import { ProductPod } from '@thd-olt-component-react/product-pod';

const Product = extend({
  itemId: stringType(),
  dataSources: stringType(),
  pricing: params({ storeId: stringType() }).shape({
    original: numberType(),
    value: numberType(),
    message: stringType(),
    promotion: {
      dollarOff: numberType({ float: true }),
      percentageOff: numberType()
    }
  }),
  reviews: shapeType({
    ratingsReviews: shapeType({
      averageRating: stringType(),
      totalReviews: stringType()
    })
  }),
  media: shapeType({
    images: arrayType({
      url: stringType(),
      sizes: arrayType(stringType())
    })
  }),
  identifiers: shapeType({
    itemId: stringType(),
    productLabel: stringType(),
    canonicalUrl: stringType(),
    brandName: stringType()
  })
}, ProductPod.dataModel.product);

export const dataModel = extend({
  searchModel: params({
    keyword: stringType()
  }).shape({
    aisles: arrayType(shapeType({
      shopAllUrl: stringType(),
      aisleCategory: stringType(),
      aisleBrand: stringType(),
      aislePosition: stringType(),
      aisle: arrayType(shapeType({
        name: stringType(),
        displayName: stringType(),
        shopAllUrl: stringType(),
        products: arrayType(shapeType(Product))
      }))
    })),
    searchReport: shapeType({
      keyword: stringType()
    })
  })
});
